import { range } from 'lodash-es';
import { TranscriptFormat } from 'api/services/transcript';
import { TranscriptFormatItem } from './types';

export const transcriptFormatList: TranscriptFormatItem[] = [
  {
    label: 'TXT',
    value: 'txt',
  },
  {
    label: 'PDF',
    value: 'pdf',
  },
  {
    label: 'Doc',
    value: 'docx',
  },
  {
    label: 'VTT',
    value: 'vtt',
  },
  {
    label: 'SRT',
    value: 'srt',
  },
];

export const YOUTUBE_FORMATTING_UNSUPPORTED_EXPORT_FORMATS: TranscriptFormat[] =
  ['pdf', 'docx'];

export const SPEAKER_LABEL_FORMATTING_UNSUPPORTED_EXPORT_FORMATS: TranscriptFormat[] =
  ['pdf', 'docx'];

export const SLICE_BY_CHAR_COUNT_UNSUPPORTED_EXPORT_FORMATS: TranscriptFormat[] =
  ['txt', 'pdf', 'docx'];

export const SPEAKER_FREQUENCY_UNSUPPORTED_EXPORT_FORMATS: TranscriptFormat[] =
  ['txt'];

export const TIMESTAMPS_SUPPORTED_EXPORT_FORMATS: TranscriptFormat[] = [
  'pdf',
  'docx',
];

export const FORMATS_TO_INCLUDE_EDGE_SHIFT: TranscriptFormat[] = ['srt', 'vtt'];

export const MAX_CHARACTERS_PER_LINE_DEFAULT = 50;

export const MAX_CHARACTERS_PER_LINE_MIN = 30;

export const MAX_CHARACTERS_PER_LINE_MAX = 300;

export const MAX_CHARACTERS_PER_LINE_STEP = 10;

export const MAX_CHARACTER_PER_LINE_VALUES = range(
  MAX_CHARACTERS_PER_LINE_MIN,
  // Lodash range end value is exclusive, so we need to add the step to the max.
  MAX_CHARACTERS_PER_LINE_MAX + MAX_CHARACTERS_PER_LINE_STEP,
  MAX_CHARACTERS_PER_LINE_STEP,
);
